/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LimitChargeTransactionTask
 */
export interface LimitChargeTransactionTask {
    /**
     *
     * @type {number}
     * @memberof LimitChargeTransactionTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {number}
     * @memberof LimitChargeTransactionTask
     */
    transactionId?: number;
    /**
     *
     * @type {number}
     * @memberof LimitChargeTransactionTask
     */
    maxChargeKw?: number;
    /**
     *
     * @type {number}
     * @memberof LimitChargeTransactionTask
     */
    maxDischargeKw?: number;
    /**
     *
     * @type {Date}
     * @memberof LimitChargeTransactionTask
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the LimitChargeTransactionTask interface.
 */
export function instanceOfLimitChargeTransactionTask(
    value: object,
): value is LimitChargeTransactionTask {
    return true;
}

export function LimitChargeTransactionTaskFromJSON(
    json: any,
): LimitChargeTransactionTask {
    return LimitChargeTransactionTaskFromJSONTyped(json, false);
}

export function LimitChargeTransactionTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): LimitChargeTransactionTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        maxChargeKw:
            json["maxChargeKw"] == null ? undefined : json["maxChargeKw"],
        maxDischargeKw:
            json["maxDischargeKw"] == null ? undefined : json["maxDischargeKw"],
        endTime:
            json["endTime"] == null ? undefined : new Date(json["endTime"]),
    };
}

export function LimitChargeTransactionTaskToJSON(
    value?: LimitChargeTransactionTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        transactionId: value["transactionId"],
        maxChargeKw: value["maxChargeKw"],
        maxDischargeKw: value["maxDischargeKw"],
        endTime:
            value["endTime"] == null
                ? undefined
                : value["endTime"].toISOString(),
    };
}
